import { Skeleton, Paper, Typography } from "@mui/material";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { useFetchModuleSettings } from "src/Pages/Company/OrganizationStructure/api/useModuleSettings";
import __ from "src/utils/Translations";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import ErrorDataFetching from "src/Components/Error/ErrorDataFetching";
import React from "react";
import { useCompanyBreadcrumbs } from "src/Pages/Company/breadcrumbsHelper";
import { AxiosError } from "axios";
import { useLogStatus } from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/useLogStatus/useLogStatus";
import { NewRelicLogLevel } from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/useLogStatus/useLogStatus.models";
import Form from "./Form/Form";

const ModuleSettings = () => {
  const companyId = useCompanyId();
  const logStatus = useLogStatus();
  const {
    data,
    isError,
    isFetching,
    error: moduleSettingsError,
  } = useFetchModuleSettings(companyId);

  if (moduleSettingsError) {
    const error = moduleSettingsError as AxiosError;
    logStatus({
      type: NewRelicLogLevel.ERROR,
      message: "ModuleSettings: fetchModuleSettings failed",
      statusDetails: {
        source: "API",
        operation: "fetchModuleSettings",
        status: error.response?.status,
        url: error.config?.url,
      },
    });
  }

  const breadcrumbs = useCompanyBreadcrumbs([
    {
      label: __("Struktura organizacji"),
      path: "/organization-structure",
    },
    {
      label: __("Ustawienia modułu"),
      path: "/organization-structure/module-settings",
    },
  ]);

  return (
    <>
      <BreadcrumbsMui items={breadcrumbs} sx={{ marginBottom: "32px" }} />
      <Typography
        sx={{ fontSize: "24px", textTransform: "upperCase" }}
        fontWeight="fontWeightBold"
      >
        {__("Ustawienia modułu")}
      </Typography>
      <Paper
        sx={{
          width: "100%",
          maxWidth: "955px",
          borderRadius: "16px",
          margin: "46px 0 0 0",
          padding: "32px",
          boxShadow:
            "0px 4px 24px 0px rgba(166, 166, 166, 0.20), 0px 1px 1px 0px #F2F2F2",
        }}
      >
        {isFetching ? (
          <Skeleton variant="rounded" height={434} />
        ) : (
          <>
            {isError || !data ? (
              <ErrorDataFetching />
            ) : (
              <Form initialValues={data} companyId={companyId} />
            )}
          </>
        )}
      </Paper>
    </>
  );
};

export default ModuleSettings;
